<template lang="pug">
  e-input-file-upload(
    v-model="files"
    ref="fileInput"
    multiple
    :can-delete="canDelete"
    :rules="rules"
    :name="$t('Document')"
    :allowed-extensions="extensionsMap"
    :accept="acceptedFileExtensions"
    :uploader-background-image="require('~/assets/sprite/svg/papers-box.svg')"
    :uploader-background-image-styles="uploaderImageStyles"
  )
    template(v-slot:description)
      div(class="text-12px light mb-6") {{ descriptionFormatText }}
</template>

<script>
import upload from '~/modules/documents/mixins/upload'
import EInputFileUpload from '~/components/elements/inputs/e-input-file-upload'

export default {
  name: 'EInputDocumentUpload',
  components: {
    EInputFileUpload
  },
  mixins: [upload],
  props: {
    canDelete: {
      type: Boolean,
      default: false
    },
    uploadedFile: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      files: []
    }
  },
  computed: {
    descriptionFormatText() {
      return this.$t('Supported formats:') + ' JPG,JPEG,PNG,DOC,DOCX,XLS,XLSX,PDF,TXT,P7S'
    },
    uploaderImageStyles() {
      return {
        position: 'absolute',
        bottom: '0',
        right: '20px',
        zIndex: 1
      }
    }
  },
  watch: {
    files(files) {
      this.$emit('input', files)
    }
  },
  created() {
    if (this.uploadedFile) {
      this.files.push(this.uploadedFile)
    }
  },
  methods: {
    validate() {
      return this.$refs.fileInput.validate()
    }
  }
}
</script>

<style lang="scss">
.uploader {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 200px;

  cursor: pointer;
  border-radius: 12px;
  border: 2px dashed $primary;
  background: $white;

  padding: 40px 56px;

  &.errored {
    border-color: $danger;
  }

  &.drag-n-drop {
    border-color: $primary;
  }

  &__content {
    text-align: center;
  }
}
</style>
